import { gql } from '@apollo/client'

const BASE_STUDY_NOTE_FIELDS = gql`
  fragment BaseStudyTypeFields on StudyNoteType {
    id
    name
    description
    link
    order
    membershipLevel
    isBoosterEnvironment
    studyNoteGroup {
      id
      color
      title
    }
  }
`

export const FIND_ALL_STUDY_NOTES = gql`
  ${BASE_STUDY_NOTE_FIELDS}
  query findAllStudyNote($query: StudyNoteQueryInput = {}) {
    findAllStudyNote(query: $query) {
      count
      items {
        createdAt
        ...BaseStudyTypeFields
      }
    }
  }
`

export const CREATE_STUDY_NOTE = gql`
  mutation createStudyNote($params: CreateStudyNoteInput!) {
    createStudyNote(createStudyNoteInput: $params) {
      id
    }
  }
`

export const UPDATE_STUDY_NOTE = gql`
  mutation updateStudyNote($params: UpdateStudyNoteInput!) {
    updateStudyNote(updateStudyNoteInputFieldName: $params) {
      id
    }
  }
`

export const DELETE_STUDY_NOTE = gql`
  mutation removeStudyNote($removeStudyNoteId: String!) {
    removeStudyNote(id: $removeStudyNoteId) {
      affected
    }
  }
`

export const BULK_UPDATE_STUDY_NOTE = gql`
  mutation bulkUpdateStudyNote($bulkUpdateStudyNoteInput: [BulkUpdateStudyNoteInput!]!) {
    bulkUpdateStudyNote(bulkUpdateStudyNoteInput: $bulkUpdateStudyNoteInput) {
      id
    }
  }
`

export const BULK_REMOVE_STUDY_NOTE = gql`
  mutation bulkRemoveStudyNote($ids: [LinkStudyNoteInput!]!) {
    bulkRemoveStudyNote(ids: $ids) {
      affected
    }
  }
`
